import { createSlice } from '@reduxjs/toolkit';

// Correctly initialize initialState with type annotation
const initialState = {
  menuName: [],
};

const addMenuTitleSlice = createSlice({
  name: 'menuTitle',
  initialState,
  reducers: {
    addMenuTitle: (state, action) => {
      state.menuName = action.payload;
    },

  
  },
});

export const { addMenuTitle } = addMenuTitleSlice.actions;
export default addMenuTitleSlice.reducer;
